export default "__VITE_ASSET__Cus04bGw__"